import { render, staticRenderFns } from "./EditPanel.vue?vue&type=template&id=442ab5ae&"
import script from "./EditPanel.vue?vue&type=script&lang=js&"
export * from "./EditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports